import { JobProfileDetailComponent } from './../../components/job-module/job-profile-detail/job-profile-detail.component';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { countProvider } from 'src/app/components/suggestions/suggestions.component';
import { JobCardComponent } from 'src/app/components/cards/job-card/job-card.component';
import { AppSettings } from 'src/app/services/AppSettings';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { UtilService } from 'src/app/services/util.service';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateJobDetailsComponent } from 'src/app/components/candidate-job-details/candidate-job-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-jobs-appliedBy-The-user',
  standalone: true,
  imports: [
    CommonModule,
    JobCardComponent,
    CommonSkeletonComponent,
CandidateJobDetailsComponent,
    InfiniteScrollModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './jobs-appliedBy-The-user.component.html',
  styleUrls: ['./jobs-appliedBy-The-user.component.scss']
})
export class JobsAppliedByTheUserComponent implements OnInit, OnChanges {

  @Input() maxMin: any = {};
  viewType: string = "MIN";

  jobAppliedByTheUser =new BehaviorSubject<any>([]);
  jobAppliedByTheUserAfterKey : string = "";
  jobAppliedByTheUserStopScroll :boolean = false ;
  subscription: Subscription;
  loaddata:boolean=false;
  loadAPIcall:boolean=false
  page : any;
  obj: any = {
    limit: 10,
    searchAfterKey : null,
    userId: localStorage.getItem('userId')
  }



  constructor(private jobService : JobService ,
    private util :UtilService , private JobServicecolor: JobService,
    private provider : countProvider) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.maxMin && changes.maxMin.currentValue) {
      this.maxMin = changes.maxMin.currentValue;
      if (this.maxMin.viewType) {
        this.viewType = this.maxMin.viewType;
      }
    }
  }

  ngOnInit() {
    if (this.maxMin && this.maxMin.viewType) {
      this.viewType = this.maxMin.viewType;
    }
    this.apiCall();
    this.subscription = this.JobServicecolor.confirmationResult$.subscribe(() => {
      this.apiCall();
    });
  }
  ngOnDestroy(): void {
    if (this.subscription) {
     this.subscription.unsubscribe();
   }
 }
  totalCount : any =  0;
  apiCall(){

    if(this.jobAppliedByTheUserStopScroll){
      return;
    }
    this.loadAPIcall=true;
    this.jobService.findJobAppliedByTheUser(this.obj).subscribe(res=>{
     this.loaddata=true;
     this.loadAPIcall=false;
      const resData = res.jobsApplied;
      const afterKey = res.searchAfterKey;

      if(resData){

        if(this.jobAppliedByTheUserAfterKey === afterKey || resData.length  === 0){
          this.jobAppliedByTheUserStopScroll = true;
        }

        const data = resData.map(ele => {
          // Check if it's a direct job object or wrapped
          if (ele.jobDetails && ele.user) {
            // Wrapped structure - copy user from wrapper root into jobDetails
            ele.jobDetails.user = ele.user;

            // Construct fullname from firstName and lastName if fullname is null
            if (!ele.jobDetails.user.fullname && (ele.jobDetails.user.firstName || ele.jobDetails.user.lastName)) {
              ele.jobDetails.user.fullname = `${ele.jobDetails.user.firstName || ''} ${ele.jobDetails.user.lastName || ''}`.trim();
            }

            // Format photo URL
            if (ele.jobDetails.user.photo) {
              ele.jobDetails.user.photo = AppSettings.photoUrl + ele.jobDetails.user.photo;
            } else {
              ele.jobDetails.user.photo = null;
            }
          } else if (ele.user) {
            // Direct job object - format photo directly
            // Construct fullname from firstName and lastName if fullname is null
            if (!ele.user.fullname && (ele.user.firstName || ele.user.lastName)) {
              ele.user.fullname = `${ele.user.firstName || ''} ${ele.user.lastName || ''}`.trim();
            }

            if (ele.user.photo) {
              ele.user.photo = AppSettings.photoUrl + ele.user.photo;
            } else {
              ele.user.photo = null;
            }
          }

          return ele;
        });

        const combined = [...this.jobAppliedByTheUser.getValue() , ...data];
        this.jobAppliedByTheUser.next(combined);
        this.jobAppliedByTheUserAfterKey = afterKey;

        if(this.totalCount===0){
          this.totalCount = res.total;
          this.provider.setCount(this.totalCount , "JobsAppliedByTheUserComponent");
        }

        this.util.stopLoader();

      }

    },err=>{
      this.loaddata=false;
      this.util.stopLoader();
    });
  }

  pagecount(event) {
    this.page = event;
    this.obj.pageNumber = event - 1;
    this.apiCall();
  }

  onScrollDown(){
    if(!this.jobAppliedByTheUserStopScroll&& this.obj.searchAfterKey != this.jobAppliedByTheUserAfterKey){
      this.obj.searchAfterKey = this.jobAppliedByTheUserAfterKey;
      this.apiCall();
    }
  }


}
